import { render, staticRenderFns } from "./PaginationControl.vue?vue&type=template&id=404bb164&"
import script from "./PaginationControl.vue?vue&type=script&lang=ts&"
export * from "./PaginationControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports